import React, { Component } from 'react';

interface Props {
  onItemPress: (item: any) => void;
  onChange: (item: any) => void;
  rowItem: (item: any) => React.ReactNode;
  filter: (item: any) => void;
  onSelect: (item: any) => void;
  placeholder: string;
  value: string;
  field: string;
  list: any[];
}

export default class DropdownInput extends Component<Props> {
  static defaultProps = {
    onItemPress: () => {},
    onChange: () => {},
    rowItem: () => {},
    filter: () => {},
    placeholder: 'Search',
    value: '',
    field: '',
    list: [],
  };

  dropdown = () => {
    //console.log('length is: ' + this.props.value.length);
    //console.log('list is:' + this.props.list);
    if (this.props.value.length > 0) {
      let list = this.props.list.filter(this.props.filter).map((item, index) => {
        return (
          <li key={index} className='list-group-item' style={{ cursor: 'pointer' }} onMouseUp={() => this.props.onSelect(item)}>
            {this.props.rowItem(item)}
          </li>
        );
      });
      let length = list.length;
      list.splice(10);
      if (length > 10) {
        list.push(
          <li key='more-results' className='list-group-item text-center'>
            <i>{` ${length - 10} More Results`}</i>
          </li>
        );
      }
      return list;
    }
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <input
          type='text'
          className='form-control'
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={(e) => this.props.onChange(e.target.value.replace(/[&;$%@"<>()+,?^|*]/g, ''))}
        />
        <ul className='list-group'>{this.dropdown()}</ul>
      </div>
    );
  }
}
